// extracted by mini-css-extract-plugin
export default {"wrapper":"FormItemError_wrapper__t9Hqf","left":"FormItemError_left__oeGV-","right":"FormItemError_right__2Uoli"};